export enum HeadingVariant {
  ALFA = 'ALFA',
  BRAVO = 'BRAVO',
  CHARLIE = 'CHARLIE',
  DELTA = 'DELTA',
  ECHO = 'ECHO',
  FOXTROT = 'FOXTROT',
}
